import { Subactivity } from '../../models/subactivity';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import { SubactivityBuilder } from '../../models/builders/subactivity.builder';

const subactivityBody = (subactivity: Subactivity) => ({
  name: subactivity.name,
  activityHash: subactivity.activity,
  manual: subactivity.manual,
  time: subactivity.time
});

@Injectable()
export class SubactivityApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }subactivities`;
  }

  createSubactivity(subactivity) {
    return this.httpClient.post(this.apiUrl, subactivityBody(subactivity)).pipe(map(SubactivityBuilder.fromJson));
  }

  deleteSubactivity(subactivity: Subactivity) {
    return this.httpClient.delete(`${ this.apiUrl }/${ subactivity.hash }`);
  }

  getSubactivities() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(SubactivityBuilder.fromList));
  }

  getSubactivity(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(SubactivityBuilder.fromJson));
  }

  updateSubactivity(subactivity: Subactivity) {
    return this.httpClient.put(`${ this.apiUrl }/${ subactivity.hash }`, subactivityBody(subactivity));
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/subactivity-api.service.ts